import React from "react";
import { ReferenceInput } from "react-admin";
import { AutocompleteInput } from "ra-ui-materialui/lib/input/AutocompleteInput";
import { storagePlacesFilterToQuery } from "./_helpers/storagePlaces";

export const StoragePlaceReferenceInput = ({
	terminalId,
	filter = {},
	autocompleteProps = {},
	...props
}) => {
	return (
		<ReferenceInput
			reference="storage-places-lookup"
			sort={{ field: "address", order: "ASC" }}
			filter={{ terminal_id: terminalId, ...filter }}
			filterToQuery={storagePlacesFilterToQuery}
			perPage={25}
			{...props}
		>
			<AutocompleteInput
				optionText="address"
				resettable
				{...autocompleteProps}
			/>
		</ReferenceInput>
	);
};
